import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  inject,
  Injector,
  input,
  OnInit,
  Output,
  runInInjectionContext,
  signal
} from '@angular/core';
import { OptionItem } from '../../molecules/option-item/option-item';
import { OptionItemComponent } from '@view/shared/molecules/option-item/option-item.component';

/**
 * Componente que representa una lista de opciones.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-option-list',
  imports: [CommonModule, OptionItemComponent],
  template: `
    <ul>
      @for (item of _items(); track $index) {
        <li
          tabindex="0"
          class="my-2 ml-1 cursor-pointer p-2 hover:outline hover:outline-2 hover:outline-primary-300 hover:ring-offset-0 hover:bg-primary-200 hover:text-white"
          [ngClass]="{ 'bg-blue-800 text-white': item.active && selectable }"
          (click)="onItemClick(item)"
          (keydown.enter)="onItemClick(item)"
        >
          <app-option-item
            [onlyIcon]="onlyIcons()"
            [item]="item"
            iconPosition="left"
          ></app-option-item>
        </li>
      }
    </ul>
  `,
  styles: `
    ul {
      list-style-type: none;
      padding: 0;
    }
  `
})
export class OptionListComponent implements OnInit {
  /** Lista de items. */
  items = input.required<OptionItem[]>();
  /** Indica si los items son seleccionables. */
  selectable = input(false);

  onlyIcons = input(false);

  /** Emite el evento de click sobre un item. */
  @Output() itemClick = new EventEmitter<OptionItem>();

  injector = inject(Injector);

  _items = signal<OptionItem[]>([]);

  ngOnInit(): void {
    runInInjectionContext(this.injector, () => {
      effect(() => {
        this._items.set(this.items());
      });
    });
  }

  /**
   * Maneja el evento de click sobre un item.
   * @param optionItemSelected item seleccionado.
   */
  onItemClick(optionItemSelected: OptionItem) {
    if (this.selectable()) {
      this._items.set(
        this.items().map((item) => {
          return {
            ...item,
            active: item.id === optionItemSelected.id
          };
        })
      );
    }

    this.itemClick.emit(optionItemSelected);
  }
}
